import { LoadingIndicator } from '@shipt/design-system-loading'
import { Row } from '@shipt/design-system-layouts'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { useEffect } from 'react'

export const SearchRedirect = ({ url }: { url: string }) => {
  const router = useSegwayRouter()

  useEffect(() => {
    router.replace(url)
  }, [url, router])
  return (
    <Row align="center" justify="center" marginTop="5xl">
      <LoadingIndicator size="xl" />
    </Row>
  )
}
